<template>
  <div>
    <div class="dashboard">
      <app-sidemenu class="app-sidemenu" v-on:logout="dialogVisible = true"></app-sidemenu>
      <router-view class="app-router"></router-view>
      <app-sidebar class="app-sidebar" v-on:logout="dialogVisible = true"></app-sidebar>
    </div>

    <el-dialog width="280px" title="Logout" :visible.sync="dialogVisible">
      <span>ログアウトしますか？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">いいえ</el-button>
        <el-button type="primary" @click="logout">はい</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AppSidemenu from '@/components/app/AppSidemenu'
import AppSidebar from '@/components/app/AppSidebar'

export default {
  name: 'dashboard',
  components: {
    'app-sidemenu': AppSidemenu,
    'app-sidebar': AppSidebar
  },
  data: function () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    logout: function (ev) {
      this.$store.dispatch('wordpress/account/logout')
      this.dialogVisible = false
      setTimeout(function () { window.location.reload() }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';

.app {
  &-sidemenu {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
  }
}
@media (min-width: 1025px) {
  .app {
    &-sidemenu {
      display: block;
    }
    &-sidebar {
      display: none;
    }
    &-router {
      margin-left: $app_sidemenu_width;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/AppDashboard.vue